import { Stack, Typography } from '@mui/material'
import { ErrorCircle16Regular } from '@/components/Icon'

/**
 * Shown when a turn failed after its answer had already streamed. The answer
 * above is real and worth keeping; this says only that it may be cut short.
 */
export default function IncompleteAnswerNotice({ message }) {
  if (!message) return null
  return (
    <Stack
      direction="row"
      sx={{
        gap: 1,
        alignItems: 'flex-start',
        px: 1.25,
        py: 1,
        borderRadius: 1,
        border: '1px solid var(--app-status-blocked-fg)',
        color: 'var(--app-text-secondary)',
      }}
    >
      <ErrorCircle16Regular fontSize={14} style={{ marginTop: 2, flexShrink: 0 }} />
      <Typography sx={{ fontSize: 13 }}>
        This answer may be incomplete — the response stopped early. {message}
      </Typography>
    </Stack>
  )
}
